import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWrapper, ButtonLabel } from './styles';

const StandingButton = ({
  background, label, color, linkTo, borderColor, width, isTitleNarrowMedium, margin, size,
}) => (
  <ButtonWrapper
    background={background}
    href={linkTo}
    borderColor={borderColor}
    width={width}
    margin={margin}
  >
    <ButtonLabel
      color={color}
      isTitleNarrowMedium={isTitleNarrowMedium}
      size={size}
    >
      {label}
    </ButtonLabel>
  </ButtonWrapper>
);

StandingButton.propTypes = {
  label: PropTypes.string,
  color: PropTypes.any,
  background: PropTypes.any,
  linkTo: PropTypes.any,
  borderColor: PropTypes.any,
  width: PropTypes.string,
  isTitleNarrowMedium: PropTypes.bool,
  margin: PropTypes.string,
  size: PropTypes.string,
};

export default StandingButton;



// WEBPACK FOOTER //
// ./src/components/shared/StandingButton/index.js